'use client';

import React from 'react';

import { OrganGameAnswer } from './organ-game-answer';
import { OrganGameSVG } from './organ-game-svg';

export function OrganGameBoardSkeleton() {
  return (
    <div>
      <OrganGameSVG />
      <div className='h-[154px] w-full' />
    </div>
  );
}

type Answer = {
  id: string;
  name: string;
  content: string;
};
interface OrganGameBoardProps {
  answer: Answer;
  answers: Array<Answer>;
  finishGame: () => void;
  setMoves: React.Dispatch<React.SetStateAction<number>>;
}

export function OrganGameBoard({ answer, answers, finishGame, setMoves }: OrganGameBoardProps) {
  const [guesses, setGuesses] = React.useState<Array<string>>([]);

  const correctAnswerId = answer.id;

  const checkCompletion = React.useCallback(() => {
    if (guesses.includes(correctAnswerId)) {
      finishGame();
    }
  }, [correctAnswerId, finishGame, guesses]);

  const handleAnswerClick = React.useCallback(
    (answerId: string) => {
      if (guesses.includes(correctAnswerId) || guesses.includes(answerId)) {
        return;
      }
      setGuesses((prev) => [...prev, answerId]);
      setMoves((moves) => moves + 1);
    },
    [correctAnswerId, guesses, setMoves],
  );

  React.useEffect(() => {
    checkCompletion();
  }, [checkCompletion]);

  return (
    <div>
      <OrganGameSVG activeOrgan={correctAnswerId} />
      <div className='flex flex-col gap-y-2'>
        {answers.map((answerOption, idx) => (
          <OrganGameAnswer
            answer={answerOption.name}
            index={idx}
            isCorrectGuess={guesses.includes(answerOption.id) && answerOption.id === correctAnswerId}
            isGameOver={guesses.includes(correctAnswerId)}
            isIncorrectGuess={guesses.includes(answerOption.id) && answerOption.id !== correctAnswerId}
            key={answerOption.id}
            onClick={() => handleAnswerClick(answerOption.id)}
          />
        ))}
      </div>
    </div>
  );
}
